import { useEffect } from "react";

import { adjacentListPages } from "@/lib/adjacent-list-pages";

/** Warm previous and next server pages after the current page settles. */
export function usePrefetchAdjacentListPages({
  enabled,
  isFetching,
  page,
  pageSize,
  totalCount,
  prefetchPage,
}: {
  enabled: boolean;
  isFetching: boolean;
  page: number;
  pageSize: number;
  totalCount: number;
  prefetchPage: (page: number) => void;
}) {
  useEffect(() => {
    if (!enabled || isFetching) return;
    for (const adjacent of adjacentListPages(page, pageSize, totalCount)) {
      prefetchPage(adjacent);
    }
  }, [enabled, isFetching, page, pageSize, prefetchPage, totalCount]);
}
